<form
  [formGroup]="form"
  (ngSubmit)="sendSupport()"
  class="add-connecting">
  <h2 class="headline">{{ "SUPPORT_PAGE.MODAL.TITLE" | translate }}</h2>

  <div class="scroll-block">
    <div class="form-frame__body-inputs">
      <div
        [class.error]="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched"
        class="input-block textarea">
        <textarea
          formControlName="commentFormControl"
          maxlength="1000"
          id="comment"
          class="input"
          placeholder=" ">
        </textarea>
        <label
          for="comment"
          class="placeholder">
          {{ "SUPPORT_PAGE.MODAL.MESSAGE" | translate }} *
        </label>
        <ng-container *ngIf="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched">
          <span
            *ngIf="commentRequiredError"
            class="input-block__error">
            {{ "SUPPORT_PAGE.MODAL.ERROR.COMMENT_REQUIRED" | translate }}
          </span>
        </ng-container>

        <ng-container *ngIf="!(form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched)">
          <span class="input-block__count">
            <span *ngIf="!form.controls['commentFormControl'].value">0</span>
            <span *ngIf="form.controls['commentFormControl'].value">
              {{ form.controls["commentFormControl"].value.length }}
            </span>
            / 1000
          </span>
        </ng-container>
      </div>
    </div>
    <app-form-custom-select
      formControlName="typeFormControl"
      [errorText]="typeRequiredError"
      [itemList]="supportTypeList"
      [positionList]="'top'"
      [isSmall]="true"
      title="{{ 'SUPPORT_PAGE.MODAL.TYPE' | translate }} *">
    </app-form-custom-select>
    <ng-container>
      <div
        id="files"
        class="form-frame__body-file">
        <ngx-file-drop
          dropZoneLabel="Drop files here"
          (onFileDrop)="dropped($event)"
          (onFileOver)="fileOver($event)"
          (onFileLeave)="fileLeave($event)">
          <ng-template
            ngx-file-drop-content-tmp
            let-openFileSelector="openFileSelector">
            <button
              (click)="openFileSelector()"
              type="button"
              class="download-btn">
              <img
                src="assets/img/attach.svg"
                alt="Attach"
                class="download-btn__image" />
              <span class="download-btn__content">
                {{ "AGREEMENT.ATTACH" | translate }}
                <span class="download-btn__content-description">
                  {{ "AGREEMENT.DRUG_AND_DROP" | translate }}
                </span>
              </span>
            </button>
          </ng-template>
        </ngx-file-drop>
      </div>
      <ul class="form-frame__body-attach-list">
        <li
          class="file-item"
          *ngFor="let item of files; let i = index">
          {{ item.relativePath }}
          <button
            (click)="deleteFile(i)"
            class="file-item__delete"></button>
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="btn-block">
    <button
      type="submit"
      [disabled]="this.form.invalid || isSending"
      class="btn btn-accent">
      {{ "SUPPORT_PAGE.MODAL.SEND" | translate }}
    </button>
    <button
      type="button"
      (click)="close()"
      class="btn btn-light">
      {{ "SUPPORT_PAGE.MODAL.CANCEL" | translate }}
    </button>
  </div>
</form>
